import { usePluginContext } from '../../context/PluginContext';

export function useUpdateDestinationMap() {
  return usePluginContext().updateDestinationMap;
}
